import React from 'react';
import PropTypes from 'prop-types';

import {
  FormControl,
  Select,
  MenuItem,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  select: {
    color: theme.palette.primary[600],
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '1.25px',
    textTransform: 'uppercase'
  },
  icon: {
    fill: theme.palette.primary[600]
  }
}));

const NavBarSelect = props => {
  const classes = useStyles();
  const { id, options, selectedOption, handleChange, ...rest } = props;

  return (
    <FormControl variant="outlined" size="small" {...rest}>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={selectedOption}
        onChange={handleChange}
        inputProps={{
          classes: {
            icon: classes.icon,
            root: classes.select
          }
        }}
      >
        {options.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
      </Select>
    </FormControl>
  )
}

NavBarSelect.propTypes = {
  id: PropTypes.string,
  handleChange: PropTypes.func,
  options: PropTypes.array,
  selectedOption: PropTypes.string
}

export default NavBarSelect;
